// code color shortcut

export const Black = '#2A2B2A';
export const White = '#F9F9F9';
export const Yellow = '#FAC710';
export const Grey = '#D9D9D9';
export const DarkGrey = '#444444';
export const LightDarkGrey = '#666666';
export const Green = '#8CC63F';
export const LightGreen = '#00FF00';
export const Red = '#ED1C24';
export const DarkYellow = '#D5B60A';

/* for the opacity: 
  100%: add + 'FF'
  80%: add + 'CC'
  60%: add + '99'
*/
